import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import DeviceInfoDrawer from "./modules/DeviceInfoDrawer";
import DeviceDrawer from "./modules/DeviceDrawer";
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { getAction } from '@/api/manage';
import DeviceBatchAddDrawer from "./modules/DeviceBatchAddDrawer.vue";
import ScrapDrawer from "../../om/asset/modules/ScrapDrawer";
export default {
  name: 'ProductInfoList',
  mixins: [JeecgListMixin],
  components: {
    DeviceInfoDrawer: DeviceInfoDrawer,
    DeviceDrawer: DeviceDrawer,
    DeviceBatchAddDrawer: DeviceBatchAddDrawer,
    ScrapDrawer: ScrapDrawer
  },
  data: function data() {
    return {
      pagePath: '/ea/asset/info',
      pageTitle: '产品清单',
      autoLoadInit: false,
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'assetCode',
        colName: 'asset_code',
        title: '资产编号',
        align: 'center'
      }, {
        dataIndex: 'productName',
        colName: 'productName',
        title: '产品名称',
        align: 'center'
      }, {
        dataIndex: 'insideName',
        colName: 'insideName',
        title: '内部名称',
        align: 'center'
      }, {
        dataIndex: 'model',
        colName: 'model',
        title: '规格型号',
        align: 'center'
      }, {
        dataIndex: 'companyName',
        colName: 'companyName',
        title: '供应商',
        align: 'center'
      }, {
        dataIndex: 'sn',
        colName: 'sn',
        title: '出厂编号',
        align: 'center'
      }, {
        dataIndex: 'purchaseDate',
        colName: 'purchase_date',
        title: '购置日期',
        align: 'center'
      }, {
        dataIndex: 'siteName',
        colName: 'site_name',
        title: '保管站点',
        align: 'center'
      }, {
        dataIndex: 'status_dictText',
        colName: 'status',
        title: '资产状态',
        align: 'center'
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }],
      deviceColumns: [{
        dataIndex: 'netWorth',
        colName: 'net_worth',
        title: '净值（元）',
        align: 'center'
      }, {
        dataIndex: 'installDate',
        colName: 'install_date',
        title: '安装日期',
        align: 'center'
      }],
      chemicalColumns: [{
        dataIndex: 'density',
        colName: 'density',
        title: '标准值',
        align: 'center'
      }, {
        dataIndex: 'danger_dictText',
        colName: 'danger',
        title: '是否危化品',
        align: 'center'
      }, {
        dataIndex: 'certificateNo',
        colName: 'certificate_no',
        title: '证书编号',
        align: 'center'
      }, {
        dataIndex: 'surplus',
        colName: 'surplus',
        title: '剩余量(ml)',
        align: 'center'
      }],
      attachmentColumns: [{
        dataIndex: 'surplus',
        colName: 'surplus',
        title: '剩余量',
        align: 'center'
      }],
      companyList: [],
      siteList: [],
      columnsInfo: [],
      url: {
        queryCompany: '/ea/company/info/queryCompanyName',
        site: '/site/info',
        delete: '/ea/asset/info',
        device: '/ea/asset/equipment',
        chemical: '/ea/asset/chemical',
        attachment: '/ea/asset/attachment',
        car: '/ea/asset/car',
        list: '/ea/asset/info',
        scrap: '/om/asset/scrap/find/'
      }
    };
  },
  props: {
    danger: {
      type: Number,
      default: 2
    },
    category: {
      type: Number,
      default: 11
    },
    title: {
      type: String,
      default: '设备'
    }
  },
  created: function created() {
    this.loadCompany();
    this.columnsInfo = [];
    this.queryParam.category = this.category;

    if (this.category == 11 || this.category == 12) {
      this.url.delete = this.url.device;
      this.url.list = this.url.device;
      this.columnsInfo = this.insert(this.columns, this.deviceColumns, 6);
    } else if (this.category == 21 || this.category == 22 || this.category == 23) {
      this.url.delete = this.url.chemical;
      this.columnsInfo = this.insert(this.columns, this.chemicalColumns, 9);
      this.url.list = this.danger == 1 ? this.url.chemical + '?danger=' + this.danger : this.url.chemical;
    } else if (this.category == 91 || this.category == 92) {
      this.url.delete = this.url.attachment;
      this.url.list = this.url.attachment;
      this.columnsInfo = this.insert(this.columns, this.attachmentColumns, 9);
    } else if (this.category == 31) {
      this.url.delete = this.url.car;
      this.columnsInfo = this.columns;
    } else if (this.category == null && this.danger == 1) {
      debugger;
      this.url.delete = this.url.chemical;
      this.columnsInfo = this.insert(this.columns, this.chemicalColumns, 9);
      this.url.list = this.danger == 1 ? this.url.chemical + '?danger=' + this.danger : this.url.chemical;
    }

    this.loadData();
    this.$forceUpdate();
  },
  computed: {},
  methods: {
    loadCompany: function loadCompany() {
      var that = this;
      that.companyList = [];
      that.siteList = [];
      getAction(this.url.queryCompany).then(function (res) {
        if (res.success) {
          that.companyList = res.result;
        }
      });
      var params = {
        size: -1,
        status: 1
      };
      getAction(this.url.site, params).then(function (res) {
        if (res.success) {
          that.siteList = res.result.records;
        }
      });
    },
    handleBatchAdd: function handleBatchAdd() {
      this.$refs.batchModal.category = this.category;
      this.$refs.batchModal.title = '批量新增：' + this.title;
      this.$refs.batchModal.disableSubmit = false;
      this.$refs.batchModal.disableName = false;
      this.$refs.batchModal.showTab = true;
      this.$refs.batchModal.add();
    },
    handleAdd: function handleAdd() {
      this.$refs.modalForm.category = this.category;
      this.$refs.modalForm.title = '新增：' + this.title;
      this.$refs.modalForm.disableSubmit = false;
      this.$refs.modalForm.disableName = false;
      this.$refs.modalForm.showTab = true;
      this.$refs.modalForm.add();
    },
    handleEdit: function handleEdit(record) {
      this.$refs.modalForm.category = this.category;
      this.$refs.modalForm.title = '编辑：' + this.title;
      this.$refs.modalForm.disableSubmit = false;
      this.$refs.modalForm.disableName = true;
      this.$refs.modalForm.showTab = true;
      this.$refs.modalForm.edit(record);
    },
    handleDetail: function handleDetail(record) {
      this.$refs.deviceModal.category = this.category;
      this.$refs.deviceModal.title = this.title + '详情';
      this.$refs.deviceModal.disableSubmit = true;
      this.$refs.modalForm.disableName = true;
      this.$refs.modalForm.showTab = true;
      this.$refs.deviceModal.edit(record);
    },
    handleCover: function handleCover(record) {
      this.$refs.modalForm.category = this.category;
      this.$refs.modalForm.disableName = false;
      this.$refs.modalForm.title = '复制：' + this.title;
      this.$refs.modalForm.disableSubmit = false;
      this.$refs.modalForm.showTab = false;
      this.$refs.modalForm.edit(record);
    },
    handleDelete: function handleDelete(record) {
      var param = {
        assetId: record.id,
        productName: record.productName
      };
      this.$refs.scrapForm.category = this.category;
      this.$refs.scrapForm.edit(param);
      this.$refs.scrapForm.title = '新增资产报废：';
      this.$refs.scrapForm.disableSubmit = false;
      this.$refs.scrapForm.showTab = false;
      this.$refs.scrapForm.showContact = false;
    },
    handleDeleteDetail: function handleDeleteDetail(record) {
      var _this = this;

      getAction(this.url.scrap + record.id).then(function (res) {
        if (res.success) {
          _this.$refs.scrapForm.edit(res.result);

          _this.$refs.scrapForm.title = '资产报废详情：';
          _this.$refs.scrapForm.disableSubmit = true;
          _this.$refs.scrapForm.showTab = false;
          _this.$refs.scrapForm.showContact = false;
        }
      });
    },
    modalFormOk: function modalFormOk() {
      // this.queryParam = { category: this.category }
      this.loadData();
    },
    searchReset: function searchReset() {
      this.queryParam = {
        category: this.category
      };
      this.dates = {};
      this.loadData(1);
    },
    insert: function insert(arrfirst, arrlast, index) {
      if (index < 0) {
        index = 0;
      } else if (index > arrfirst.length) {
        index = arrfirst.length;
      }

      for (var i = arrlast.length - 1; i >= 0; i--) {
        arrfirst.splice(index, 0, arrlast[i]); //是在index位置用arrlast[i]替换掉arrfirst数组中的0个元素
      }

      return arrfirst;
    }
  }
};